const translations = {
  title: "Reports & Daily Close",
  subtitle: "Daily and monthly analytics, print logs, daybook, and system audits.",
  // Tabs
  tab_dailyClose: "Daily Close",
  tab_gst: "GST Report",
  tab_goldPosition: "Gold Position",
  tab_branch: "Branch Report",
  tab_printLogs: "Print Logs",
  tab_audit: "Audit Log",
  // Daily Close
  dailyClose: "Daily Close",
  newDailyClose: "New Daily Close",
  closeDate: "Close Date",
  openingVault: "Opening Vault Gold",
  closingVault: "Closing Vault Gold",
  goldIssued: "Gold Issued to Karigars",
  goldReceived: "Gold Received from Karigars",
  finishedCreated: "Finished Items Created",
  scrapReturned: "Scrap Returned",
  soldFine: "Sold (Fine Gold)",
  karigarOutstanding: "Karigar Outstanding",
  // Cash summary
  cashSummary: "Cash Summary",
  invoiceCount: "Total Invoices",
  salesTotal: "Sales Total",
  cashTotal: "Cash",
  upiTotal: "UPI",
  bankTotal: "Bank / NEFT",
  cardTotal: "Card",
  outstandingTotal: "Outstanding Given",
  gstCollected: "GST Collected",
  repairPayments: "Repair Payments",
  workerWithdrawals: "Worker Withdrawals",
  physicalCashCounted: "Physical Cash Counted",
  expectedCash: "Expected Cash",
  cashVariance: "Cash Variance",
  // Checklist
  checklist: "End-of-Day Checklist",
  cashCounted: "Cash counted & verified",
  goldChecked: "Gold stock checked",
  pendingOrdersReviewed: "Pending orders reviewed",
  karigarCustodyReviewed: "Karigar custody reviewed",
  printReportsSaved: "Print reports saved",
  // Balance sheet
  balanceSheet: "Balance Sheet",
  balanced: "BALANCED",
  discrepancy: "Discrepancy",
  totalUnderManagement: "Total Gold Under Management",
  // Signatures
  managerSignature: "Manager",
  ownerSignature: "Owner",
  closeNotes: "Notes",
  finalizeClose: "Finalize Day Close",
  printReport: "Print Report",
  // GST Report
  gstReport: "GST Report",
  gstPeriod: "Period",
  totalTaxable: "Total Taxable Value",
  cgst: "CGST",
  sgst: "SGST",
  igst: "IGST",
  totalGst: "Total GST",
  gstInvoices: "Taxable Invoices",
  // Gold Position
  goldPosition: "Gold Position Report",
  vaultGold: "Vault Gold",
  karigarGold: "Gold with Karigars",
  finishedGold: "Finished Stock (Gold)",
  customerGold: "Customer Gold Held",
  scrapGold: "Scrap Gold",
  totalGold: "Total Gold",
  // Print Logs
  printLogs: "Print Logs",
  printDate: "Date",
  printType: "Type",
  printRef: "Reference",
  printUser: "User",
  // Columns
  col_date: "Date",
  col_invoiceNo: "Invoice No.",
  col_customer: "Customer",
  col_amount: "Amount",
  col_gst: "GST",
  col_type: "Type",
  col_action: "Action",
  // Empty states
  noDailyClose: "No daily close records yet.",
  noPrintLogs: "No print logs yet.",
  noGstData: "No GST data for this period.",
};

export default translations;
